import React from 'react';
import {
  CheckCircleIcon,
  DotsHorizontalIcon,
  EyeIcon,
  InformationCircleIcon,
  ShieldExclamationIcon,
  UserRemoveIcon,
  XCircleIcon,
} from '@heroicons/react/solid';
import {
  Button,
  ButtonGroup,
  Card,
  Dropdown,
  FormCheck,
  OverlayTrigger,
  Tooltip,
  Image,
} from 'react-bootstrap';
import { ToggleAction } from './ToggleAction';
import { StorageModule } from '@vlinder-web/storage-module-react';

import * as S from './styles';

const capitalizeFirstLetter = (string: any) =>
  string[0].toUpperCase() + string.slice(1);

const getFirstLetterOfEachWord = (text: any) => {
  try {
    let Rtext = text && text !== '' ? text?.match(/\b\w/g).join('') : '';
    console.log(`Rtext`, Rtext, Rtext.length);
    if (Rtext && Rtext.length > 2) {
      return Rtext.substring(0, 2);
    } else {
      return Rtext;
    }
  } catch (error) {}
};

export const DomainTableRow = (props: any) => {
  console.log('Asirdata DomainTableRow props:', props);
  const {
    id,
    verified,
    status,
    image,
    name,
    firstName,
    lastName,
    middleName,
    applicationId,
    savedOn,
    applicationType,
    email,
    dateCreated,
    isSelected,
    selectUser,
    deleteUsers,
    onTogglePress,
    whoAmI,
    onViewDetailClick,
    onViewClick,
    role,
    data,
    amount,
    paymentId,
    type,
    orgName,
    paymentType,
    paidOn,

  } = props;
  console.log("asdasdfasf",props);
  const VerifiedIcon = verified ? CheckCircleIcon : InformationCircleIcon;
  const storageSrv = StorageModule?.getInstance();
  const userProfile = storageSrv.get('myProfile', 'session');

  const variantColor =
    status === 'Employer Draft' || status === 'Applicant Draft'
      ? '#FE8D01'
      : '#0000FF';

  const paymentTypeColor =
    paymentType === 'APP_PROCESSING_FEE' ? '#6F42C1'
  : paymentType === 'WORK_PERMIT_FEE' ? '#E83E8C'
  : '#0000FF';
  const statusColor =
    status === 'Success' ? '#28A745' 
  : status === 'Processing' ? '#FFC107' 
  : status === 'Authorized' ? '#17A2B8'
  : status === 'Failed' ? '#DC3545' 
  : '#0000FF'; 

  const statusVariant =
    status === 'active'
      ? 'success'
      : status === 'created'
      ? 'warning'
      : status === 'invited'
      ? 'purple'
      : status === 'verified'
      ? 'purple'
      : status === 'suspended'
      ? 'danger'
      : 'primary';

  const onToggle = (key: string) => {
    console.log('_onViewClick onToggle', applicationId, key, data, 'id:', id);
    if (key === 'view') {
      onViewClick && onViewClick(applicationId, data);
    } else {
      onTogglePress && onTogglePress(key, applicationId);
    }
  };

  const renderCircle = (roles: any) => {
    const colors = ['008000', '800080', 'A52A2A', 'FF7F50', 'd2d2d2', '29A6A6'];

    const output: any = [];

    const returnImg = () => {
      if (Array.isArray(roles)) {
        roles?.forEach((item, index) => {
          output.push(
            <li className="d-inline-block">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">{item}</Tooltip>}
              >
                <Image
                  style={{ width: '40px' }}
                  className="img-40 rounded-circle"
                  src={`https://ui-avatars.com/api/?name=${item}&background=${colors[index]}&color=fff`}
                />
              </OverlayTrigger>
            </li>
          );
        });
      }
      if (typeof role === 'string') {
        const randomIndex = Math.floor(Math.random() * colors.length);
        output.push(
          <li className="d-inline-block">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip className="m-0">{role}</Tooltip>}
            >
              <Image
                style={{ width: '40px' }}
                className="img-40 rounded-circle"
                src={`https://ui-avatars.com/api/?name=${role}&background=${colors[randomIndex]}&color=fff`}
              />
            </OverlayTrigger>
          </li>
        );
      }
      return output;
    };

    return (
      <div
        className="roleAvatar"
        style={{ width: '100%', inlineSize: 'max-content' }}
      >
        <ul style={{ paddingLeft: '0px' }}>{returnImg()}</ul>
      </div>
    );
  };

  return (
    <tr className="border-bottom user-table">
      {/* <td>
        <FormCheck type="checkbox" className="dashboard-check">
          <FormCheck.Input
            id={`user-${id}`}
            checked={isSelected}
            onChange={() => selectUser(id)}
          />
          <FormCheck.Label htmlFor={`user-${id}`} />
        </FormCheck>
      </td> */}
       <td>
        <Card.Link className="d-flex align-items-center">
          {image ? (
            <Image src={image} className="avatar rounded-circle me-3" />
          ) : name ? (
            <div className="avatar d-flex align-items-center justify-content-center fw-bold rounded bg-secondary me-3">
              <span>{getFirstLetterOfEachWord(name)}</span>
            </div>
          ) : (
            ' - '
            )}
          <div className="d-block">
            <span className="fw-normal">{name}</span>
          </div>
        </Card.Link>
      </td>

      <td>
        <span className="fw-normal">{paymentId}</span>
      </td>

      <td>
        <span className="fw-normal" style={{ color: paymentTypeColor }}>
          {paymentType === 'APP_PROCESSING_FEE' && 'Application Processing Fee'}
          {paymentType === 'WORK_PERMIT_FEE' && 'Work Permit Fee'}
        </span>
      </td>

      {/* <td>
         <ToggleAction
          status={status}
          onTogglePress={onToggle}
          whoAmI={whoAmI}
        /> 
        <span className="fw-normal">{status}</span>
      </td> */}

      <td>
        <span className="fw-normal">
          <S.ButtonComp className= {` rounded-pill btn-sm`} color={statusColor}>
          {status && capitalizeFirstLetter(status)}
          </S.ButtonComp>    
        </span>
      </td>

      <td>
          <span className="fw-normal">{amount}</span>
      </td>

      <td>
        <span className="fw-normal">{paidOn}</span>
      </td>

      {/* <td>
        <span className={`fw-normal `}>
          <S.ButtonComp className= {`btn rounded-pill btn-sm`} color={variantColor}>{status && capitalizeFirstLetter(status)}</S.ButtonComp>     
        </span>
      </td> */}

      <td>
          <span className="fw-normal">{applicationId}</span>
      </td>

      <td>
        <span className="fw-normal">{orgName}</span>
      </td>
      
      {/* <td>
        <span className="fw-normal">{applicationType}</span>
      </td> */}
      {/* <td>
        <span className={`fw-normal `}>
          <S.ButtonComp className= {`btn rounded-pill btn-sm`} color={variantColor}>{status && capitalizeFirstLetter(status)}</S.ButtonComp>     
        </span>
      </td> */}
      {/* <td className="mw-20">
        <span className="fw-normal d-flex align-items-center">
          {role}
          {renderCircle(role)}
        </span>
      </td> */}
      {/* <td>
        {userProfile?.email !== email ? (
          <>
          {userRole?.name === "owner" && (
            <OverlayTrigger
            placement="top"
            overlay={<Tooltip className="m-0">Delete</Tooltip>}
            >
                <Card.Link
                className="ms-2"
                onClick={() => deleteUsers && deleteUsers(id)}
                >
                <XCircleIcon className="icon icon-xs text-danger" />
                </Card.Link>
                </OverlayTrigger>
                )}
                </>
                ) : null}
              </td> */}
    </tr>
  );
};
